var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 2.75H14.25C15.2089 2.75013 16.1286 3.13041 16.8075 3.8075L19.1925 6.1925C19.8696 6.87144 20.2499 7.79114 20.25 8.75V19.25C20.25 20.0456 19.9339 20.8087 19.3713 21.3713C18.8087 21.9339 18.0456 22.25 17.25 22.25H6.75C5.95435 22.25 5.19129 21.9339 4.62868 21.3713C4.06607 20.8087 3.75 20.0456 3.75 19.25V5.75C3.75 4.95435 4.06607 4.19129 4.62868 3.62868C5.19129 3.06607 5.95435 2.75 6.75 2.75V2.75Z",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 7.25V2.75C15.2089 2.75013 16.1286 3.13041 16.8075 3.8075L19.1925 6.1925C19.8696 6.87144 20.2499 7.79114 20.25 8.75H15.75C15.3522 8.75 14.9706 8.59196 14.6893 8.31066C14.408 8.02936 14.25 7.64782 14.25 7.25Z",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.dd7688638d9cd08475c442ea55c05003.svg";
export { ForwardRef as ReactComponent };